export default "__VITE_ASSET__CsIixJCx__"